export class TaxCheckBoxModel {
  [key: string]: boolean

  hasPayrollEncumbrance:boolean = false;
  isIcmsCreditAllowed:boolean = false;
  hasPresumedProfit:boolean = false;
  hasPresumedIcmsCredit:boolean = false;
  isCreditWithoutAssetAllowed:boolean = false;
}
